var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outline-gray-button-container"},[_c('button',{staticClass:"outline-gray-button-button button buttonSmall",attrs:{"onclick":"document.getElementById(\"below\").scrollIntoView()"}},[_vm._v(" "+_vm._s(_vm.button)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }